import {Box, Divider} from '@mui/material';
import ArrButton from '../../../common/arr-button/ArrButton';
import {t} from 'i18next';
import {ReactComponent as PlusIcon} from '../../../../assets/images/add.svg';
import {ReactComponent as ExpandCollapseIcon} from '../../../../assets/images/expand-collapse-icon.svg';
import ArrIconButton from '../../../common/arr-icon-button/ArrIconButton';
import './TranscriptHeaderAction.scss';

interface HeaderProps {
  onNewChatClick?: () => void;
  onCollapseClick?: () => void;
  disableNewChat?: boolean;
}
const TranscriptHeaderAction: React.FC<HeaderProps> = ({
  onNewChatClick,
  onCollapseClick,
  disableNewChat,
}) => {
  return (
    <Box
      className="transcript-actions-wrapper"
      data-testid="transcript-header-action"
    >
      <ArrButton
        aria-label={t('ai.investigate.transcripts.new')}
        variant="primary"
        size="xs"
        dataTestId="transcript-new-btn"
        onClick={onNewChatClick}
        disabled={disableNewChat}
        className="add-new-btn"
        endIcon={
          <PlusIcon
            className={`plus-icon ${disableNewChat ? 'icon-inactive' : ''}`}
          />
        }
      >
        {t('ai.investigate.transcripts.new')}
      </ArrButton>
      <Divider orientation="vertical" className="button-divider" />
      <ArrIconButton
        className="collapse-button"
        icon={<ExpandCollapseIcon />}
        size="small"
        onClick={onCollapseClick}
        ariaLabel={t('ai.investigate.transcripts.collapse')}
        data-testid="collapse-button"
        testId="transcript-header-action-collapse-icon-button" />
    </Box>
  );
};

export default TranscriptHeaderAction;
